import { useMemo } from "react";
import { useBakeryStore } from "../game/bakeryStore";
import { avatarCdnUrl } from "@cookies/shared/cdn";
import type { LeaderboardEntry } from "../game/types";

export default function Top5() {
  const store = useBakeryStore();
  const snap = store.snapshot;
  const entries = useMemo(() => {
    const src = snap?.leaderboard ?? snap?.players ?? [];
    const list = [...src] as LeaderboardEntry[];
    list.sort((a, b) => {
      const ac = typeof a.bestTesterCps === "number" && Number.isFinite(a.bestTesterCps) ? a.bestTesterCps : 0;
      const bc = typeof b.bestTesterCps === "number" && Number.isFinite(b.bestTesterCps) ? b.bestTesterCps : 0;
      if (bc !== ac) return bc - ac;
      const at = Number(a.totalClicks ?? 0);
      const bt = Number(b.totalClicks ?? 0);
      if (bt !== at) return bt - at;
      return a.userId < b.userId ? -1 : a.userId > b.userId ? 1 : 0;
    });
    return list.slice(0, 5);
  }, [snap]);
  if (entries.length === 0) return null;
  return (
    <div className="cb-panel" style={{ padding: 10 }}>
      <h3 className="cb-sec" style={{ marginTop: 0, marginBottom: 8 }}>⚡ Top 5 CPS</h3>
      <div style={{ display: "flex", gap: 10, overflowX: "auto" }}>
        {entries.map((e) => {
          const url = avatarCdnUrl(e.userId, e.avatar ?? "", 64);
          const cps = typeof e.bestTesterCps === "number" && Number.isFinite(e.bestTesterCps) ? e.bestTesterCps : 0;
          return (
            <div key={e.userId} style={{ display: "flex", flexDirection: "column", alignItems: "center", minWidth: 72 }}>
              <span style={{ width: 44, height: 44, borderRadius: 22, overflow: "hidden", background: e.color, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800 }}>
                {url !== "" ? <img src={url} alt={e.name} width={44} height={44} style={{ width: "100%", height: "100%", objectFit: "cover" }} loading="lazy" /> : e.name.slice(0, 1)}
              </span>
              <small style={{ marginTop: 4, fontWeight: 700, maxWidth: 72, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{e.name}</small>
              <small className="dim" style={{ fontSize: 12 }}>{cps.toFixed(1)} CPS</small>
            </div>
          );
        })}
      </div>
    </div>
  );
}
